import type { OnDestroy } from '@angular/core';
import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import type { MentionElement, MentionElementGroup } from '@core/prosemirror-legacy';
import type { MentionsStream$ } from '@core/prosemirror-legacy/angular';

@Injectable()
export class FilteredMentions$
  extends BehaviorSubject<MentionElement[] | MentionElementGroup[]>
  implements MentionsStream$, OnDestroy
{
  constructor() {
    super([]);
  }
  public ngOnDestroy() {
    this.complete();
  }
}
